import { object, string } from 'yup'

export default object().shape({
  mid: string().required('hqm.support-page.create-ticket.fields.mid.validation'),
  topic: string().required('hqm.support-page.create-ticket.fields.topic.validation'),
  subject: string().required('hqm.support-page.create-ticket.fields.subject.validation'),
  description: string().required('hqm.support-page.create-ticket.fields.description.validation')
})
